export { default } from './OuterCorner';
